
<div class="val-texte-couleur-colonne val-flex-conteneur">
  <div class="val-texte-couleur-colonne-contenu val-flex-conteneur"
       [style.background-color]="couleurFond"
       [style.color]="couleur"
       [ngClass]="{'val-invisible': valeur === null}">
    <val-fonte-icone class="val-texte-couleur-colonne-icone"
                     [iconeCss]="icone">
    </val-fonte-icone>
    <div class="val-texte-couleur-colonne-texte-conteneur val-flex-1 val-flex-conteneur val-flex-colonne">
      <div class="val-flex-1"></div>
      <div class="val-texte-couleur-colonne-texte">
        {{texte}}
      </div>
      <div class="val-flex-1"></div>
    </div>
  </div>
</div>
